import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import ManageSubscription from "@components/views/Profile/ManageSubscription";
import ProfileLayout from "@components/core/ProfileLayout";
import SharedAccountsLayout from "@components/core/SharedAccountsLayout";

const ManageSubscriptionPage = () => (
  <>
    <SharedAccountsLayout
      title="title_manage_subscription"
      className="d-lg-none"
    />
    <ProfileLayout>
      <ManageSubscription />
    </ProfileLayout>
  </>
);

export async function getServerSideProps({ params: { locale } }) {
  return {
    props: {
      ...(await getMessagesForNamespaces(locale, ["common", "accounts"])),
    },
  };
}

export default ManageSubscriptionPage;
